import React from "react";
import { useParams } from "react-router";
import { MembersSearchDropdown } from "./improved_components/members_search_dropdown";

export function MembersSearchDropdownWithServerId(
	props: Omit<React.ComponentProps<typeof MembersSearchDropdown>, "guild_id">
) {
	let { server_id } = useParams<{
		server_id: string;
	}>();

	return (
		<MembersSearchDropdown
			{...props}
			guild_id={server_id}
			onUpdate={(ids) => props.onUpdate(ids)}
		/>
	);
}
